<template>
    <div class="animated fadeIn">
        <b-card>
            <div slot="header">   
                <i class="fa fa-money"></i> Cobrança de Aluguel             
                <b-button v-if="$auth.isPartner || $auth.isFinance" variant="primary" class="btn mr-2 btn-sm float-right" @click="createRentalChargeModalVisible = true">
                    <i class="fa fa-plus"></i>
                    Entrada
                </b-button>
            </div>                
            <b-card-body>
                <form @submit.prevent="validate">
                    <div class="form-row justify-content-start" v-if="$auth.isPartner || $auth.isFinance">                                   
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Empresa</label>
                                <model-list-select
                                    :list="customers.data"
                                    option-value="id"
                                    option-text="name"
                                    v-model="selectedCustomer"
                                    :placeholder="'Digite o nome da empresa'"
                                    @searchchange="searchCustomers"
                                ></model-list-select>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="form-group">
                            <label for="exampleFormControlSelect2">Data cobrança:</label>
                            <select :class="{'custom-select': true}" v-model="request.chargeDate">
                                <option v-for="(s, index) in chargeDateList" :key="index" :value="s.id">{{s.name}}</option>
                            </select>
                            </div>
                        </div>
                    </div>              
                    <input type="submit" class="btn btn-primary" value="Buscar" />
                </form>
            </b-card-body>
        </b-card>        
        <b-card>
            <b-table
                :items="result.data"
                :fields="rentalChargesColumns"
                :striped="true"
                responsive
            >        
                <template slot="status" slot-scope="data">{{bindStatusName(data.value)}}</template>
                <template slot="chargeDate" slot-scope="data">{{formatDateTimeFields(data.value)}}</template>
                <template slot="amount" slot-scope="data">{{formatDecimalFields(data.value)}}</template>
                <template slot="actions" slot-scope="row">        
                    <button v-show="actionUri != ''" @click.prevent="onCustomActionClick('view', row)" class="btn mr-2 btn-md btn-primary action-btn">
                        <i class="fa fa-search"></i>
                    </button>
                    <button v-if="row.item.status == 'CREATED'"  title="Cobrar" @click.prevent="onCustomActionClick('charge', row)" class="btn mr-2 btn-md btn-dark action-btn">
                        <i class="fa fa-money"></i>
                    </button>              
                </template>
            </b-table>
            <nav>
                <b-pagination
                :total-rows="result.rowCount"
                :per-page.sync="result.pageSize"
                v-model="currentPage"
                prev-text="Voltar"
                next-text="Próximo"
                @change="pageIndexChanged"
                first-text="Primeiro"
                last-text="Último"
                />
            </nav>
        </b-card>
        <b-modal
            id="createRentalCharge-modal"
            ref="modal"
            title="Gerar cobrança de aluguel"
            @ok="handleOk"
            @hidden="resetModal"
            ok-title="Salvar"
            cancel-title="Cancelar"
            v-model="createRentalChargeModalVisible"
            :ok-disabled="createRentalChargeModalButtonDisabled"
            :cancel-disabled="createRentalChargeModalButtonDisabled"
        >
        <div
            class="alert alert-danger"
            role="alert"
            v-show="createRentalChargeModel.hasError"
        >{{createRentalChargeModel.errorMessage}}</div>
        <form ref="form" @submit.stop.prevent="handleSubmit">
            <div class="form-row">
                <div class="col-sm-12">
                    <div class="form-group">
                    <label>Selecione uma empresa para gerar a cobrança</label>
                    <model-list-select
                        :list="sellersModal.data"
                        option-value="id"
                        option-text="name"
                        v-model="createRentalChargeModel.sellerId"
                        placeholder="Digite o nome da empresa"
                        @searchchange="searchSellersModal"
                    ></model-list-select>
                    </div>
                </div>            
            </div>
            <div class="form-row">
                <div class="col-sm-12">
                    <div class="form-group">
                    <label for="exampleFormControlSelect2">Data cobrança:</label>
                    <select :class="{'custom-select': true}" v-model="createRentalChargeModel.chargeDate">
                        <option v-for="(s, index) in chargeDateListModal" :key="index" :value="s.id">{{s.name}}</option>
                    </select>
                    </div>
                </div>
            </div>
        </form>
        </b-modal>   
    </div>
</template>
<script>
import domainService from "../../services/Devices/deviceRentalChargeService";
import sellerService from "../../services/Customer/sellerService";
import { ModelListSelect } from "vue-search-select";
import * as lang from "vuejs-datepicker/src/locale";
import listPage from '../../mixins/listPage';
import moment from 'moment';
export default {
    mixins: [listPage],
    components: {
        ModelListSelect
    },
    data() {
        return {
            actionUri: "reports/devicerentalcharges",
            request: {               
                sellerId: '',
                status: '',
                chargeDate: '',
                page: 1,
                pageSize: 0,
                keywords: "",
            },
            customers: {
                data: [],
                query: '',
            }, 
            selectedCustomer: {
                id: '',
                name: ''
            },          
            languages: lang,            
            rentalChargesColumns: [
                { key: "sellerDocument", label: "Documento", sortable: false },
                { key: "sellerName", label: "Seller", sortable: false },
                { key: "contractName", label: "Contrato", sortable: false },
                { key: "chargeDate", label: "Data Cobrança", sortable: false },
                { key: "amount", label: "Valor", sortable: false },
                { key: "status", label: "Status", sortable: false },
                { key: "actions", label: "" }
            ],
            createRentalChargeModalButtonDisabled: false,
            createRentalChargeModalVisible: false,
            createRentalChargeModel: {
                sellerId: null,
                sellerName: '',
                chargeDate: '',
                hasError: false,
                errorMessage: ''
            },
            sellersModal: {
                data: [],
                query: ""
            },
            chargeDateList: [],
            chargeDateListModal: [],
            currentPage: 1
        }
    },
    created() {
        if(this.$auth.isSeller) {
            this.request.sellerId = this.$auth.customerId;            
        }
        this.bindChargeDateList();
    },
    methods: {
        bindChargeDateList() {            
            this.chargeDateListModal = domainService.getChargeDateAvailableList();
            this.chargeDateListModal.unshift({id: '', name: 'Selecione um mês'})

            this.chargeDateList = domainService.getChargeDateList();
            this.chargeDateList.unshift({id: '', name: 'Selecione um mês'})
        },
        validate() {              
            this.fetchData(1);
        },        
        fetchData(page) {
            const self = this;
            this.showLoading();
            if(!this.$auth.isSeller) {
                this.request.sellerId = this.selectedCustomer.id;
            }
            this.request.page = page;
            domainService.findAll(this.request).then(
                response => {
                    self.$data.result =
                    response.status == 204 ? self.getEmptyResult() : response.data;
                    self.hideLoading();
                },
                () => {
                    self.hideLoading();
                }
            );
        },
        searchCustomers(newQuery) {
            if (newQuery == null || newQuery.length < 2) return;
            const self = this;
            
            sellerService.all(newQuery).then(
                (response) => {
                    self.customers.data = response.status == 204 ? [] : response.data;
                },
                () => {
                    self.customers.data = [];
                }
            );                        
        },
        searchSellersModal(newQuery) {
            if (newQuery == null || newQuery.length < 2) return;
            const self = this;
            
            sellerService.all(newQuery).then(
                (response) => {
                    self.sellersModal.data = response.status == 204 ? [] : response.data;
                },
                () => {
                    self.sellersModal.data = [];
                }
            );                        
        },
        resetModal() {
            this.createRentalChargeModel.sellerId = null;            
            this.createRentalChargeModel.chargeDate = '';
            this.createRentalChargeModel.hasError = false;
            this.createRentalChargeModel.errorMessage = "";
        },
        handleOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault();
            this.createRentalChargeModel.errorMessage = "";
            this.createRentalChargeModel.hasError = false;
            if(this.createRentalChargeModel.sellerId == null || this.createRentalChargeModel.sellerId == '') {
                this.createRentalChargeModel.errorMessage = "- Selecione uma empresa";
                this.createRentalChargeModel.hasError = true;
                return;
            }
            // Trigger submit handler
            this.handleSubmit();
        },
        handleSubmit() {      
            const self = this;
            this.createRentalChargeModalButtonDisabled = true;
            domainService.create({sellerId: this.createRentalChargeModel.sellerId, chargeDate: this.createRentalChargeModel.chargeDate}).then(
                response => {
                self.fetchData(1);
                // Hide the modal manually
                self.$nextTick(() => {
                    self.$refs.modal.hide();
                    self.createRentalChargeModalButtonDisabled = false;
                    self.fetchData(1);
                });
                },
                error => {
                self.createRentalChargeModel.errorMessage =
                    error.response.data.message;
                self.createRentalChargeModel.hasError = true;
                self.createRentalChargeModalButtonDisabled = false;
                }
            );
        },
        formatDateTimeFields(value) {
            return value == null || value == '' ? '' : moment(value).format('DD/MM/YYYY');
        },
        formatDecimalFields(value) {
            return value == null || value == '' ? 'R$ 0,00' : value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
        bindStatusName(status){
            switch(status.toUpperCase()) {                
                case 'CREATED':
                return 'Registrado';
                case 'CANCELED':
                return 'Cancelado';
                case 'PROCESSING':
                return 'Processando';
                case 'DONE':
                return 'Finalizado';
            }
        },
        pageIndexChanged(page) {
            this.currentPage = page;
            this.fetchData(page);
        },
        onCustomActionClick(action, row) {
            switch(action) {
                case 'view':
                    this.$router.push({ path: `devicerentalcharges/${row.item.id}` });
                break;
                case 'charge':
                    const self = this;
                    self.showLoading();
                    domainService.charge({sellerId: row.item.sellerId, id: row.item.id}).then(
                        response => {
                            self.fetchData(1);         
                        },
                        error => {
                            self.hideLoading();
                        }
                    );
                break;                
            }            
        },
    }
}
</script>